<template>
    <div v-if="topSections[0]">
        <div class="rules__header rules__header-staff rules__header-section">
            <div class="text-size-18 text-bold rules__header-wrapper">
                <div class="rules__header-left" v-if="getCurrentTopSect">
                    <span>{{getCurrentTopSect.name}}</span>
                    <span @click="openSectionAdd(getCurrentTopSect)" class="i-wrapper">
                        <span  class="i i-pencil2"></span>
                        <span  class="i i-pencil2-active"></span>
                    </span>
                </div>
                <div class="rules__header-right">
					<div class="text-uppercase text-size-xs text-color-grey text-normal text-center" style="width: 140px;">
						нет доступа
					</div>
					<div class="text-uppercase text-size-xs text-color-grey text-normal text-center" style="width: 140px;">
						читатель
					</div>
					<div class="text-uppercase text-size-xs text-color-grey text-normal text-center" style="width: 140px;">
						Редактор
					</div>
                </div>
            </div>
        </div>
        <div v-if="getCurrentTopSect" class="content">

            <div class="container  staff-container">
                <div class="nothing-found nothing-found__settings" v-if="usersGrouped.length === 0">
                    <svg class="big-icon" >
                        <use xlink:href="@/assets/img/big-icons-sprite.svg#emoji-search-2"></use>
                    </svg>
                    <div class="text-size-l text-bold mt16">
                    Здесь пока ничего нет...
                    </div>
                    <div class="text-size-m mt4">Срочно сделайте что-нибудь, чтобы здесь что-нибудь было!</div>
                </div>
                <div class="staff-list" v-else>
                    <div class="staff-item" v-for="(group, index) in usersGrouped" :key="'group'+group.id">
                        <div class="name">
                            {{group.name}}
                        </div>
                        <div class="workers-list admin-access"
                                   v-if="group.users.length !== 0">
                            <div class="worker" v-for="(user, indexUser) in group.users" :key="user.id">
                                <div class="worker-name">
                                    <span class="text-size-s">{{user.name}}</span>
                                </div>
                                <!-- <input-select-new
                                    :tag="'div'"
                                    @change="changeAccess($event, index, indexUser)"
                                    :value="getCurrentUserRights(user)"
                                    :modelId="getCurrentUserRights(user)"
                                    :options="options"
                                    :placeholder="'Категория'"
                                    class="borderless"
                                    :list-style="{'max-height': 287 + 'px'}">
                                </input-select-new> -->
                                <right-radio-select
                                    @change="changeAccess($event, index, indexUser)"
                                    :value="getCurrentUserRights(user)"
                                    :index="index"
                                    :indexUser="indexUser"
                                ></right-radio-select>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <popup :is-set-styled="false" :show="popups.staffGroup.show" :name="popups.staffGroup.name" :width="400" :add-class="'add-cat'">
            <staff-group></staff-group>
        </popup>

        <popup :is-set-styled="false" :show="popups.removeStaffGroupError.show" :name="popups.removeStaffGroupError.name" :width="400" >
            <remove-staff-group-error></remove-staff-group-error>
        </popup>

        <popup :is-set-styled="false" :show="popups.addWorker.show" :name="popups.addWorker.name" :width="800" :add-class="'add-worker'">
            <add-worker></add-worker>
        </popup>
    </div>
</template>


<script>
    import {mapState} from 'vuex';
    import Popup from '@/components/modal/Popup.vue';
    import StaffGroup from '@/components/modal/rules/StaffGroup.vue';
    import RemoveStaffGroupError from '@/components/modal/rules/RemoveCatError.vue';
    import AddWorker from '@/components/modal/rules/AddWorker.vue';
    import Tooltip from '@/components/Tooltip.vue';
    import draggable from '@/helpers/vuedraggable.js';
    import InputSelect from '@/components/forms/InputSelect.vue';
    import InputSelectNew from '@/components/forms/InputSelectNew.vue';
    import RightRadioSelect from '@/components/forms/RightRadioSelect.vue';
    import SubmitBtn from '@/components/forms/SubmitBtn.vue';
    import Tumbler from '@/components/Tumbler.vue';

    export default {
        metaInfo() {
            return {
                title: 'РЕГЛАМЕНТЫ И ПРАВИЛА',
                titleTemplate: this.$store.state.options.titleTemplate
            }
        },
        name: 'SectionDetail',
        components: {
            Popup,
            StaffGroup,
            RemoveStaffGroupError,
            Tooltip,
            draggable,
            AddWorker,
            InputSelect,
            InputSelectNew,
            SubmitBtn,
            Tumbler,
            RightRadioSelect
        },
        data: function(){
            return {
                options: [
                  {name: '<span class=text-color-orange2>Читатель</span>', id: 1},
                  {name: '<span class=text-color-green>Редактор</span>', id: 2},
                  {name: '<span class=text-color-dark-blue>Модератор</span>', id: 28},
                  {name: '<span>Нет доступа</span>', id: 0}
                ],
                drag: false,
                kickUnReadAllBtnType: 'normal',
                kickActive: false,
                form: {
                    selectAccess: {
                        id: 2,
                        error: false,
                    },
                },
            }
        },
        computed: {
            ...mapState({
                popups: state => state.popups.items,
                topSections: state => state.rules.topSections,
                usersGrouped: state => state.rulesStaff.usersByDepartmentList,
                tumblers: state => state.rules.tumblers,
            }),
            getCurrentTopSect: function () {
                if(this.topSections.length > 0 && this.$route.params.id){
                    return this.$store.getters['rules/getCurrentTopSect'](this.$route.params.id);
                }
            }
        },
        methods:{
            accessTitle(rights) {
              let titles = {
                'W': 'Редактор',
                'R': 'Читатель',
                'C': 'Модератор',
              }

              return titles[rights];
            },
            accessClass(rights) {
              let classes = {
                'W': 'editor',
                'R': 'reader',
                'C': 'chief',
              }

              return classes[rights];
            },
            getCurrentUserRights: function (user) {
              let rights = {
                    'W': '2',
                    'R': '1',
                    'C': '28',
                  },
                  result = 0;

              if (rights[user.rights[this.getCurrentTopSect.id]]) {
                result = rights[user.rights[this.getCurrentTopSect.id]];
              }

              return result;
            },
            changeAccess: function(event, index, indexUser){
                this.$store.dispatch('rulesStaff/setUserSectRight',{val: event, index: index, indexUser: indexUser, curSect: this.getCurrentTopSect.id});
                //this.$store.commit('rulesStaff/setUserSectRight',{val: event, index: index, indexUser: indexUser, curSect: this.getCurrentTopSect.id});
            },
            setValue(value, index){
                this.$store.commit('rulesStaff/setUsersByDepartmentListByIndex', {
                    items: value,
                    index: index
                });
            },
            up: function(index){
                this.$store.dispatch('rulesStaff/setMoveGroup', {index: index, direction: 'up'});
            },
            down: function(index){
                this.$store.dispatch('rulesStaff/setMoveGroup', {index: index, direction: 'down'});
            },
            openStaffGroup: function (group = []) {
                this.$store.commit('rulesStaff/setEditGroup', group);
                this.$store.dispatch('popups/open', {name: this.popups.staffGroup.name});
            },
            openAddWorker: function (user = []) {
                this.$store.commit('rulesStaff/setEditUser', user);
                this.$store.dispatch('popups/open', {name: this.popups.addWorker.name});
            },
            dragSave: function (index) {
                if (this.drag) {
                    this.$store.dispatch('rulesStaff/setUserSort', {index: index});
                    this.drag = false;
                }
            },
            dragStart: function (index) {
                this.curDrugGroupIndex = index;
            },
            dragStatus: function (e) {
                this.drag = true;
            },
            openSectionAdd: function (cat) {
                this.$store.commit('rules/setEditSection',cat);
                this.$store.dispatch('popups/open', {name: this.popups.sectionAdd.name});
            },
            kickUnRead(id){
                this.$store.commit('rulesStaff/kickUnReadBtnType', {id: id,type: 'load'});
                this.$store.dispatch('rulesStaff/kickUnRead', {id: id}).then(()=>{
                    this.$store.commit('rulesStaff/kickUnReadBtnType', {id: id,type: 'normal'});
                });
            },
            kickUnReadAll(){
                this.kickUnReadAllBtnType = 'load';
                this.$store.dispatch('rulesStaff/kickUnReadAll').then(()=>{
                    this.kickUnReadAllBtnType = 'normal';
                });
            }
        },
        mounted() {
            //this.$store.commit('rules/tumblerOff', this.tumblers.editable.name);
            this.$store.dispatch('rulesStaff/getUsersByDepartment');
        },
    }
</script>
